import { render, staticRenderFns } from "./TokenPopover.vue?vue&type=template&id=95696508&scoped=true&"
import script from "./TokenPopover.vue?vue&type=script&lang=js&"
export * from "./TokenPopover.vue?vue&type=script&lang=js&"
import style0 from "./TokenPopover.vue?vue&type=style&index=0&id=95696508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95696508",
  null
  
)

export default component.exports